import { Pipe, PipeTransform } from '@angular/core';

import { ProgrammingUtilsService } from './../../../common/services/utils.service';
import { ScheduleQuickstartContext } from './../services/schedule.service';

@Pipe({
  name: 'enddateLabel'
})
export class EnddateLabelPipe implements PipeTransform {

  constructor(
    private utils: ProgrammingUtilsService
  ) { }

  transform(vm: ScheduleQuickstartContext, args?: any): any {
    let label = '';

    if (vm.hasEndDate) {
      label += 'until ';
      let parts = vm.endDate.split('-');
      label += this.utils.toDateDisplay(parseInt(parts[0]), parseInt(parts[1]), parseInt(parts[2]));
    }

    return label;
  }
}

// TOO LONG 50 character limit
// every 7 days at 8:00am from mm/dd/yyyy to mm/dd/yyyy
// every weekday at sunrise + 15m +/-20m from mmddyyy to mmddyyy

// OK
// mm/dd/yyyy @ 08:00am every 7 days
// mm/dd/yyyy every weekday at sunrise +15m +/-20m



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-schedule/pipes/enddate-label.pipe.ts